import { Container } from '@chakra-ui/react';
import { SubHeader } from '../../organisms/SubHeader';
import { MainBlocks } from '../../organisms/MainBlocks';
import { Testimonials } from '../../organisms/Testimonials';
import { PricingSection } from '../../organisms/Pricing';
import { HowItWorks } from '../../organisms/HowItWorks';
import { RevealOnScroll } from '../../atoms/RevealOnScroll';

export const MarketingLandingPage: React.FC = () => (
  <>
    <SubHeader />
    <Container px={{ base: 0 }} maxW="container.xl">
      <MainBlocks />
      <RevealOnScroll>
        <Testimonials />
      </RevealOnScroll>
      <RevealOnScroll>
        <HowItWorks />
      </RevealOnScroll>
    </Container>
    <RevealOnScroll>
      <PricingSection showAllPlans={false} />
    </RevealOnScroll>
  </>
);
